import { gql } from "@apollo/client";


export const LOAD_VIDEOS_QUERY = gql`
  query LoadVideos($tags: [String!]) {
    loadVideos(tags: $tags) {
      id
      name
      type
      description
      duration
      status
      progress
      thumbnail {
        url
      }
      hashedId
      assets {
        type
        url
        width
        height
        fileSize
        contentType
      }
      createdAt
      updatedAt
    }
  }
`;

export const LOAD_VIDEO_QUERY = gql`
  query LoadVideo($hashedId: String!) {
    loadVideo(hashedId: $hashedId) {
      id
      name
      type
      description
      duration
      status
      progress
      thumbnail {
        url
      }
      hashedId
      assets {
        type
        url
        width
        height
        fileSize
        contentType
      }
      createdAt
      updatedAt
    }
  }
`; 